import { supabase } from "@/integrations/supabase/client";

/**
 * Binds any guardian records that were created by email invitation but never
 * attached to an account (user_id IS NULL) to the currently signed-in user.
 *
 * This is what makes an invited co-parent recognised as a guardian the first
 * time they sign in with the invited address. Safe to call repeatedly — the
 * RPC is a no-op when there is nothing to bind.
 *
 * Never throws: binding is a best-effort side effect of signing in and must
 * not block navigation.
 */
export async function bindPendingGuardianInvites(): Promise<number> {
  try {
    const { data, error } = await supabase.rpc("bind_pending_guardian_invites");
    if (error) {
      console.warn("bind_pending_guardian_invites failed:", error.message);
      return 0;
    }
    return typeof data === "number" ? data : 0;
  } catch (err) {
    console.warn("bind_pending_guardian_invites threw:", err);
    return 0;
  }
}
